import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaStar } from 'react-icons/fa';
import './ReviewForm.css'; // Make sure this file exists and has styling

const ReviewForm = () => {
  const [author, setAuthor] = useState('');
  const [text, setText] = useState('');
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    axios.get('http://localhost:5000/api/custom-reviews')
      .then(res => setReviews(res.data))
      .catch(() => setMessage('❌ Failed to load reviews'));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!author || !text || !rating) {
      setMessage('❗All fields are required.');
      return;
    }

    try {
      await axios.post('http://localhost:5000/api/custom-reviews', {
        author_name: author,
        text,
        rating
      });

      setAuthor('');
      setText('');
      setRating(0);
      setMessage('✅ Review submitted!');
      
      const res = await axios.get('http://localhost:5000/api/custom-reviews');
      setReviews(res.data);
    } catch (err) {
      setMessage('❌ Could not submit review.');
    }
  };

  return (
    <div className="review-container">
      <h2>Leave a Review</h2>
      <form onSubmit={handleSubmit} className="review-form">
        <input
          type="text"
          placeholder="Your name"
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
        />
        <textarea
          placeholder="Write your review here..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <div className="star-rating">
          {[...Array(5)].map((_, index) => {
            const current = index + 1;
            return (
              <label key={current}>
                <input
                  type="radio"
                  name="rating"
                  value={current}
                  onClick={() => setRating(current)}
                />
                <FaStar
                  className="star"
                  size={28}
                  color={current <= (hover || rating) ? '#ffc107' : '#e4e5e9'}
                  onMouseEnter={() => setHover(current)}
                  onMouseLeave={() => setHover(null)}
                />
              </label>
            );
          })}
        </div>
        <button type="submit">Submit Review</button>
        {message && <p className="status-msg">{message}</p>}
      </form>

      <h3>Recent Reviews</h3>
      <div className="review-list">
        {reviews.length === 0 ? (
          <p>No reviews yet.</p>
        ) : (
          reviews.map((rev, idx) => (
            <div key={idx} className="review-card">
              <div className="review-header">
                <strong>{rev.author_name}</strong>
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} color={i < rev.rating ? '#ffc107' : '#e4e5e9'} />
                  ))}
                </div>
              </div>
              <p>{rev.text}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ReviewForm;
